import { useCallback, useContext, useState } from "react";
import { AuthContext } from "../contexts/auth";
import getServices from "../services/getServices";

const useDashboardTarefas = () => {
  // Centraliza o estado de rede para manter a página focada na apresentação.
  const { signOut } = useContext(AuthContext);
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");

  const carregar = useCallback(async (filtros) => {
    setLoading(true);
    setErro("");
    // getServices já envia o token Bearer configurado durante o login.
    const resultado = await getServices("admin/dashboard-tarefas/", filtros);
    if (resultado.type === "success") {
      setDados(resultado.data);
    } else if (resultado.data?.code === "token_not_valid") {
      // Segue o comportamento global do sistema quando o token expira.
      signOut();
    } else {
      setDados(null);
      setErro(resultado.data?.detail || "Não foi possível carregar os indicadores de tarefas.");
    }
    setLoading(false);
  }, [signOut]);

  return { dados, loading, erro, carregar };
};

export default useDashboardTarefas;
